import { gql } from '@apollo/client'

export const Query = gql`
  query EditMaintenanceSchedules($companyId: ID!, $filters: MaintenanceScheduleFilters) {
    maintenanceSchedules(companyId: $companyId, filters: $filters, first: 1) {
       nodes {
        id
        maintenanceType {
          id
          name
        }
        details
        repeatMultiplier
        repeatPeriod
      }
    }
  }
`
